import type { PassengersSchemaType } from "@/shared/schemas/flight/passengersSchema";
import type { Flight } from "@/types/services/flight/apis/Availability";
import { createStore } from "zustand/vanilla";

export type FlightState = {
  filteredFlights: Flight[];
  departFlight: Flight | null;
  isFiltered: boolean;
  isLoading: boolean;
  toggleReservedFlightModal: "open" | "close";
  passengers: {
    user: string | null;
    passengers: PassengersSchemaType | null;
  };
};

export type FlightAction = {
  setFilteredFlights: (value: FlightState["filteredFlights"]) => void;
  setIsFiltered: (value: FlightState["isFiltered"]) => void;
  setDepartFlight: (value: FlightState["departFlight"]) => void;
  setToggleReservedFlightModal: (
    value: FlightState["toggleReservedFlightModal"],
  ) => void;
  setPassengers: (value: FlightState["passengers"]) => void;
};

export type FlightStore = FlightState & FlightAction;

const defaultState: FlightState = {
  passengers: {
    user: null,
    passengers: null,
  },
  filteredFlights: [],
  departFlight: null,
  isFiltered: false,
  isLoading: false,
  toggleReservedFlightModal: "close",
};

export const createFlightStore = (initState: FlightState = defaultState) =>
  createStore<FlightStore>((set) => ({
    ...defaultState,
    setFilteredFlights: (filteredFlights) =>
      set(() => ({
        filteredFlights: Array.isArray(filteredFlights)
          ? filteredFlights.slice(0, 10)
          : [],
      })),
    setIsFiltered: (isFiltered) => set(() => ({ isFiltered })),
    setDepartFlight: (departFlight) => set(() => ({ departFlight })),
    setToggleReservedFlightModal: (toggleReservedFlightModal) =>
      set({ toggleReservedFlightModal }),
    setPassengers: (passengers) => set({ passengers }),
  }));
